import { render, staticRenderFns } from "./chart3.vue?vue&type=template&id=28b3cdaa&scoped=true&"
import script from "./chart3.vue?vue&type=script&lang=js&"
export * from "./chart3.vue?vue&type=script&lang=js&"
import style0 from "./chart3.vue?vue&type=style&index=0&id=28b3cdaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3cdaa",
  null
  
)

export default component.exports